import { useSyncExternalStore } from 'react'
import { tickSocket } from './tickSocket'

export function useMarketContext() {
  return useSyncExternalStore(tickSocket.onMarketContext, tickSocket.getMarketContext, tickSocket.getMarketContext)
}
